export function handleMultilineTextChange(
    eventValue: string, oldValue: string, maxLength?: number, onChange?: (newValue) => void) {
    let newValue = eventValue || '';
    oldValue = oldValue || '';

    if (newValue.match('^\\s+$')) {
        return;
    }

    if (maxLength) {
        // Workaround for "Safari" / "iPhone", which record new lines as 2 characters
        // That's why we can NOT just use the native maxlength
        //      attribute like `<textarea maxlength={this.props.maxlength}>`, won't work
        newValue = newValue.replace(/(\r\n|\n|\r)/g, '\n');

        if (newValue.length > maxLength) {
            // If we are only appending text, append as much as we can, up to allowed length
            // Otherwise, revert the change
            // This is the closest we get to maxLength behaviour
            newValue = newValue.startsWith(oldValue)
                ? newValue.substr(0, maxLength)
                : oldValue;
        }
    }

    if (newValue === oldValue) {
        return;
    }

    onChange(newValue);
}
